export default "__VITE_ASSET__f87686d7__"